<template>
  <div class="info-tips" ref="info">
    <div class="icon-btn_close btn-close" @click="onClose"></div>
    <div class="info-content">
      <div class="content-text" v-for="item in infoObj.message" :key="item.index" :class="item.style">
        <div style="white-space:pre-wrap" v-if="!item.style">{{item.text}}</div>
        <div v-if="item.style === 'dot-table'" class="dot-title">{{item.textTitle}}</div>
        <div v-if="item.style === 'dot-table' || item.style === 'dot'" class="dot-content">{{item.text}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'InfoTips',
  mounted () {
    let me = this
    if (me.showInfoTips) {
      me.onOpen()
    }
    document.addEventListener('click', function (e) {
      let temp = false
      let path = e.path || (e.composedPath && e.composedPath())
      path.forEach(element => {
        if (!!element.nodeName && element.nodeName !== '#document') {
          if (element.classList.length > 0) {
            if (element.className && typeof (element.className) !== 'object' && (element.className.indexOf('icon-info') > -1 || element.className.indexOf('info-tips') > -1)) {
              temp = true
            }
          }
        }
      })
      if (!temp && me.showInfoTips) {
        me.onClose()
      }
    })
  },
  methods: {
    onOpen: function () {
      let event = this.infoObj.event
      let selfHeight = this.$refs.info.offsetHeight + 20
      if (document.body.clientHeight - event.clientY < selfHeight) {
        this.$el.style.top = event.clientY - selfHeight + 'px'
      } else {
        this.$el.style.top = event.clientY + 10 + 'px'
      }
      if (document.body.clientWidth - event.clientX < 310) {
        this.$el.style.right = '5px'
      } else {
        this.$el.style.left = event.clientX + 5 + 'px'
      }
      if (this.$router.currentRoute.name !== 'portstatus') this.$el.style.maxWidth = '300px'
      this.$forceUpdate()
    },
    onClose: function () {
      this.$store.commit('updateInfoTips', false)
    }
  },
  computed: {
    ...mapState({
      showInfoTips: state => state.app.showInfoTips,
      infoObj: state => state.app.infoObj
    })
  }
}
</script>

<style lang="scss" scoped>
.info-tips {
  width: auto;
  height: auto;
  background-color: #ffffff;
  border: 1px solid #979797;
  color: #000000;
  position: absolute;
  z-index: 1002;
  user-select: none;
  font-size: 13px;
  >.info-content {
    padding: 20px;
    >.content-text {
      text-align: left;
      display: table;
      &:first-child {
        padding-top: 0px;
      }
      &.dot-table {
        display: table;
        >.dot-title {
          display: inline-table;
          margin-right: 5px;
          min-width: 70px;
          &::before {
            content: '・'
          }
        }
        >.dot-content {
          display: table-cell;
        }
      }
      &.dot::before {
        content: '・'
      }
      .dot-title {
        display: inline-block;
      }
      .dot-content {
        display: inline-block;
      }
    }
  }
  .btn-close {
    cursor: pointer;
    position: absolute;
    right: 5px;
    top: 2px;
    padding: 0px;
    color: #000000;
    &:hover {
      color: #89A5F4;
    }
    &:active {
      color: #2847A0;
    }
    &:focus {
      color: #00C8FF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/InfoTips.vue